/* eslint-disable react/no-danger */
import React, { PureComponent } from 'react';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';
import '../ReactModal/reactModal.scss';
import { getValidationClassName } from '../../util/utils';

class ValidateModal extends PureComponent {
  getValidationMarkup = list => {
    if (!list || Object.keys(list).length < 1) return null;
    const markup = [];
    list.forEach(item => {
      const itemClassName = getValidationClassName(item.status);
      markup.push(
        `<li><strong>${item.target}</strong>
          <span class=${itemClassName}>${item.status}</span>
          ${item.message ? `<br/><i>${item.message}</i>` : ''}
        </li>`,
      );
    });
    return markup.join('');
  };

  render() {
    const { timeZone } = this.props;
    if (timeZone) {
      moment.tz.setDefault(timeZone);
    }
    return this.props.dealerVerification ? (
      <div className="p-modal-container">
        <div className="p-modal">
          <div className="p-modal-text">
            <h2>
              Validation Status for{' '}
              <strong>
                {this.props.dealerVerification.dealerId} [
                {this.props.dealerVerification.type} test]
              </strong>
            </h2>
            <p className="validation-modal-status-text">
              <strong>
                <span
                  className={getValidationClassName(
                    this.props.dealerVerification.status,
                  )}
                >
                  {this.props.dealerVerification.status}
                </span>{' '}
                at{' '}
                {moment(this.props.dealerVerification.updatedAt).format(
                  'MM-DD-YYYY hh:mm',
                )}
              </strong>
            </p>
            <ul
              className="validation-status-list"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(
                  this.getValidationMarkup(
                    this.props.dealerVerification.verificationList,
                  ),
                ),
              }}
            />
          </div>

          <i
            onClick={this.props.onClose}
            className="modal-close close icon"
            alt="close"
          />
        </div>
      </div>
    ) : null;
  }
}

ValidateModal.propTypes = {
  dealerVerification: PropTypes.object,
  onClose: PropTypes.func,
  timeZone: PropTypes.string,
};

export default ValidateModal;
